module.exports = __webpack_public_path__ + "slide-1.jpg?047940975b5426197e902e2098a6f206";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slide-1.jpg
// module id = 63
// module chunks = 0